import classNames from 'classnames';
import { Translate } from '~/i18n';
import { TutorialProps } from '~/interfaces/tutorial';

type TutorialCardType = {
   tutorial: TutorialProps;
   playVideo: (tutorial: TutorialProps) => void;
   customClassName?: string;
};

const TutorialCard = ({ tutorial, customClassName, playVideo }: TutorialCardType) => {
   return (
      <div
         className={classNames(
            customClassName,
            'flex flex-col gap-2 hover:bg-gray-50 rounded min-h-full border cursor-pointer'
         )}
         onClick={() => playVideo(tutorial)}>
         <div className="relative p-3">
            {tutorial?.image ? (
               <img
                  className="w-full rounded object-cover !h-28 border"
                  src={tutorial?.image}
                  onError={({ currentTarget }) => {
                     currentTarget.onerror = null;
                     currentTarget.src = '/images/placeholder-image.svg';
                  }}
               />
            ) : (
               <img
                  height={50}
                  width={50}
                  className="w-full rounded object-cover !h-28"
                  src="/images/placeholder-image.svg"
               />
            )}
            <button className="absolute inset-0 z-10 flex items-center justify-center">
               <div className="flex items-center justify-center w-full !h-28 bg-black bg-opacity-20 m-3 rounded focus:outline-none">
                  <img alt="" src="/icons/play_arrow.svg" width="27px" height="18px" />
               </div>
            </button>
         </div>
         <hr />
         <div className="p-3 flex flex-col gap-2">
            <span className="font-semibold text-sm capitalize">{tutorial?.title}</span>
            <span className="text-xs min-h-[65px] line-clamp-4">{tutorial?.description}</span>
            <span className="text-sm text-primary cursor-pointer">
               <Translate id="tutorial:watch video" />
            </span>
         </div>
      </div>
   );
};

export default TutorialCard;
